import { connect } from 'react-redux';

import { SessionUserSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { selectSpaceInfo } from '~src/app/selectors/SpaceInfoSelectors';

import { selectContentTotalLength } from '../../selectors/ContentSelectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { AllCollectionsSpace, AllCollectionsSpaceOwnProps, AllCollectionsSpaceStateProps } from './AllCollectionsSpace';

const mapStateToProps: MapStateToProps<AllCollectionsSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  numberOfFetchedCollections: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  userDisplayName: SessionUserSelectors.sessionUserDisplayName(state)
});

export const ConnectedAllCollectionsSpace: React.ComponentClass<AllCollectionsSpaceOwnProps>
  = connect(mapStateToProps)(AllCollectionsSpace);
